import { hasAnyRoleUtil } from "../services/roleService";

export const CLIENTS_MODULE_ADMIN = "CLIENTS_MODULE_ADMIN";
export const SERALOGIN_CLIENTS_ACCESS = "SERALOGIN_CLIENTS_ACCESS";
export const CLIENTS_MASSIVE_UPLOAD_ADMIN = "CLIENTS_MASSIVE_UPLOAD_ADMIN";

export const canUploadClients = (roleList = []) =>
  hasAnyRoleUtil([CLIENTS_MODULE_ADMIN, CLIENTS_MASSIVE_UPLOAD_ADMIN], roleList);
